// extracted by mini-css-extract-plugin
export default {"main":"Home_main__WvVbz","filter":"Home_filter__7m2T0"};